import { render, staticRenderFns } from "./LoginTransit.vue?vue&type=template&id=25baa3e6&scoped=true"
import script from "./LoginTransit.vue?vue&type=script&lang=js"
export * from "./LoginTransit.vue?vue&type=script&lang=js"
import style0 from "./LoginTransit.vue?vue&type=style&index=0&id=25baa3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25baa3e6",
  null
  
)

export default component.exports